import { useOnline, useOutboxAnzahl } from '../hooks/useOutbox'
import { useTexte } from '../texte'

/**
 * Ein Streifen, wenn nichts durchgeht.
 *
 * **Er steht innerhalb der Anwendung, nicht am Rand des Fensters.** Die erste
 * Fassung saß ganz oben über allem — und in einem Safari-Tab liegt dort die
 * durchscheinende Browserleiste darüber. Übrig blieb ein blasses Band mit
 * unlesbarer Schrift: ein Hinweis, den der Browser verdeckt, ist keiner.
 *
 * Deshalb steht er jetzt im Chat **unmittelbar über der Eingabezeile**, also
 * dort, wo die Folge eintritt: wer schreibt, liest ihn im selben Blick. In der
 * Liste, wo es nichts zu schreiben gibt, sitzt er unter der Kopfzeile.
 *
 * Wartet etwas, steht die Zahl dabei. „Kein Netz" allein wäre eine Diagnose;
 * „2 warten" ist eine Auskunft.
 */
export function Netzstreifen() {
  const t = useTexte().bausteine.netz
  const online = useOnline()
  const wartend = useOutboxAnzahl()

  if (online) {
    return null
  }

  return (
    <p className="netzstreifen" role="status">
      {t.kein}
      {/* „Eintrag" und nicht „Nachricht": im Korb liegen seit den Highlights
          zwei Arten von Wartendem, und „1 Nachricht wartet" wäre bei einem
          Punkt auf der Karte schlicht falsch. */}
      {wartend > 0 ? t.wartend(wartend) : t.leer}
    </p>
  )
}
